import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/anexo-acompanhamento-medico`;

export const createAnexoAcompanhamentoMedico = async (obj) => {
  return await axios.post(`${httpUrl}/create`, obj).then((response) => response);
};

export const getAnexoAcompanhamentoMedico = async () => {
  return await axios.get(`${httpUrl}/list`).then((response) => response);
};

export const getAnexoAcompanhamentoMedicoId = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const getAnexoAcompRegistroAtendimentoId = async (idRegistroMedico) => {
  return await axios.get(`${httpUrl}/registro-atendimento/${idRegistroMedico}`).then((response) => response);
};

export const deleteAnexoAcompanhamentoMedico = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};

export const exclusaoLogica = async (obj) => {
  return await axios.post(`${httpUrl}/exclusao-logica`, obj).then((response) => response);
};
